export const EQUIPMENT_LIST_IMAGE_PARAMS =
  '?hei=64&wid=84&qlt=85,0&resMode=sharp2&op_usm=1.75,0.3,2,0';
export const EQUIPMENT_LIST_LIMIT = 25;
